import {services_zh} from "@/constant/zh/services";
import {chooseReasonInfo_zh} from "@/constant/zh/choseReasonInfo";
import {schoolList_zh} from "@/constant/zh/schoolList";
import {positionList_zh} from "@/constant/zh/positions";

export const h = {
    logo: "Logo",
    home: "首页",
    services: "公司服务",
    culture: "企业文化",
    about: "关于我们",
    cooperation: "合作",
    footer: "© 2024 WIT 公司。版权所有。",
    confirm: "确认",
    submit: "提交",
    success: "提交成功",
    product_introduction: "产品介绍",
    product_introduction_detail: "邀请朋友参加BTC价格预测游戏，赢取免费游戏机会！在线与朋友竞争，连续获胜即可解锁神秘奖励！\n" +
        "与世界各地的玩家一决高下，看看谁是真正的数字货币专家！",
    expertise: "我们的专家",
    expertise_paragraphs_1: "我们的核心专长在于分析南亚国家的商业环境，并提供国际投资风险评估、国际政策研究、国际关系分析和税收政策风险管理。",
    expertise_paragraphs_2: "我们接受私人贵宾、上市公司、跨国公司、非政府组织和其他咨询机构的委托，提供专业的咨询服务。",
    team: "我们的团队背景",
    teamBg_1: "我们拥有一支经验丰富且专业的项目管理团队，专注于为南亚地区提供全面的商业环境分析和定制化咨询服务。",
    teamBg_2: "值得注意的是，我们所有的团队成员都来自世界知名机构，如新加坡国立大学、印度理工学院和剑桥大学，他们拥有强大的学术背景和国际视野。",
    service_scope: "咨询服务范围",
    us: "美国",
    india: "印度",
    pakistan: "巴基斯坦",
    afghanistan: "阿富汗",
    slb: "斯里兰卡",
    bt: "不丹",
    npl: "尼泊尔",
    orRegion: "其他地区",
    service_title: "在充满机遇和挑战的南阿斯兰地区，WIT咨询公司为客户提供全面深入的咨询服务。我们专注于解开商业和政策环境的复杂性，引导全球客户走向成功。",
    offer_service: "我们提供如下服务",
    taxPolicy: "南亚税收政策与风险管理",
    taxPolicyInfo: "我们的税务专家深入分析南亚国家税务制度的变化，提供跨境税务筹划与风险评估服务。通过有效的税务策略，我们帮助客户优化税务负担，提升财务效率，并确保全面合规。",
    serviceSummery: "通过这些服务，WiT Consulting 支持客户在南亚的业务扩展，并加强其全球市场，致力于利用我们的专业知识和丰富的经验，为您的投资决策提供前瞻性和战略性的支持。",
    culture_title: "WIT咨询！您的专业选择！",
    company_culture_chose: "WIT Consulting! 最专业的选择。",
    company_culture_title: "我们的公司文化",
    company_culture_info: "在WIT咨询，我们的价值观不仅是我们日常运营的基础，也是我们成功的关键。它们确保我们以最高标准为客户服务，并在行业内建立强大的声誉。",
    culture_introduction1: "当客户面临阻碍其使命和梦想的技术挑战时，他们会向我们寻求帮助。我们致力于克服这些障碍，引导他们重回正轨，向目标迈进，使这一过程更加顺畅且充满回报。我们的客户一致发现，没有其他公司能像我们这样理解并支持他们。",
    culture_introduction2: "我们提供有效的数据和技术解决方案，提供有价值的见解，改进业务流程，并提升财务表现。与许多公司不同，我们深入关注每位客户的独特需求，确保解决方案能够针对其特定的挑战量身定制。这种以人为本的方法帮助我们真正支持客户的愿景。",
    choose_title: "为什么选择我们？",
    choose_reason: "WIT咨询的服务核心和企业文化塑造了我们的日常工作，并帮助我们在竞争激烈的咨询行业中保持领先地位。通过坚持这些原则，我们为客户提供高质量的咨询服务，同时促进整个团队的成长和成功。",
    culture_summery: "人人机会平等",
    culture_summery_info1: "我们是一家致力于吸引、培养和留住多样化人才的平等机会雇主。我们在做出所有雇佣决定时，都秉持非歧视原则，不考虑种族、肤色、宗教、性别、国籍、年龄、性取向、性别认同、兵役状况、公民身份、残疾状况或任何其他受保护的特征。",
    culture_summery_info2: "如果您在申请过程中或与我们合作期间需要任何特殊安排，请随时与我们联系。",
    about_title: "WIT Consulting是一家位于全球商业中心的一流国际咨询公司，专为世界各地的VIP客户提供定制咨询服务。我们的核心专长是分析南亚国家的商业环境，并提供国际投资风险评估、政策研究、地缘政治分析和税收政策风险管理。",
    about_us: "关于我们",
    talent: "人才",
    talentInfo1: "我们拥有一支经验丰富且专业的项目管理团队，致力于为南亚地区提供全面的商业环境分析和咨询服务。",
    talentInfo2: "我们的团队成员均来自世界知名大学，具备广阔的市场视野和丰富的知识。",
    about_business: "商业",
    about_businessInfo1: "我们在关键领域提供专业化的咨询服务，以帮助客户在复杂且不断变化的国际环境中取得成功。这些领域包括：商业环境分析、投资风险评估、国际政策研究、国际关系分析以及税收政策风险管理。",
    about_businessInfo2: "我们深入研究市场动态、经济条件和文化背景，帮助客户全面了解目标市场的机遇与挑战，并确保其商业战略与当地环境和趋势保持一致。",
    about_clients: "目标客户",
    about_clientsInfo: "我们是一家专注于定制化咨询服务的高端公司，致力于为各行各业的客户提供量身定制的专业建议。我们接受来自私人贵宾客户、上市公司、跨国公司和非政府组织（NGO）的委托。",
    coo_hi: "您好!",
    coo_hi_info: "我们将根据客户的具体需求，准确地将每项咨询任务分配给最合适的专家，以确保提供最高质量的解决方案。我们致力于扩大和加强我们的专家团队，并定期增加新资源，这是我们战略的关键部分。如果您有兴趣加入我们的团队，请随时提交您的简历，我们将仔细考虑每份申请。",
    coo_join: "加入我们！",
    coo_join_info: "如果您成功加入我们，您将有机会参与各种高调的咨询项目。我们将根据您的专业知识和经验来分配任务。作为回报，我们提供具有竞争力的薪酬和出色的绩效奖金，以奖励您的杰出贡献。我们期待与您共同成长，并取得更大的行业成功。",
    coo_summery: "我们鼓励退伍军人和LGBTQ+群体申请：我们致力于创造一个支持性和包容性的工作环境，欢迎来自不同背景的优秀人才加入我们的团队。",
    coo_form_title: "如果您已经准备好，请联系我们！",
    coo_website_info: "网址：www.wiexperts.com",
    coo_email: "邮箱: wiexperts@outlook.com",
    coo_phone: "电话: +60 163258515",
    coo_address: "地址: F-05-02, Persiaran Jalil 1, Bukit Jalil, Pusat PerdaganganBandar, Kuala Lumpur - 57000,\n" +
        "            马来西亚",
    coo_form_info: "我们将迅速审查您的提交内容，并在内部评估后作出回应。我们期待您的加入。",
    coo_first_name: "姓",
    coo_last_name: "名字",
    coo_your_email: "邮箱",
    coo_your_phone: "电话",
    coo_your_message: "留言",
    contact_us: "联系我们",
    menu: "菜单",
    footer_email: "邮箱:wiexperts@outlook.com",
    footer_phone: "电话:+60 163258515",
    follow_us: "关注我们",
}

/**
 * 提供哪些服务
 */
// 使用for循环遍历services数组
for (let i = 0; i < services_zh.length; i++) {
    // 构造标题属性的键名
    const titleKey = `offer_service_title${i + 1}`;
    // 构造服务属性的键名
    const serviceKey = `offer_service_${i + 1}`;
    const altKey = `offer_service_alt${i + 1}`;
    // 将title设置为固定文本，这里只是示例，可以根据需要修改
    h[titleKey] = services_zh[i].title;
    // 设置服务内容
    h[serviceKey] = services_zh[i].description;
    h[altKey] = services_zh[i].alt;
}

for (let i = 0; i < chooseReasonInfo_zh.length; i++) {
    const titleKey = `choose_reason_title${i + 1}`;
    const contentKey = `choose_reason_content${i + 1}`;
    h[titleKey] = chooseReasonInfo_zh[i].title;
    h[contentKey] = chooseReasonInfo_zh[i].detail;
}

for (let i = 0; i < schoolList_zh.length; i++) {
    const titleKey = `school_title${i + 1}`;
    const contentKey = `school_alt${i + 1}`;
    h[titleKey] = schoolList_zh[i].name;
    h[contentKey] = schoolList_zh[i].alt;
}

for (let i = 0; i < positionList_zh.length; i++) {
    const titleKey = `position_title${i + 1}`;
    h[titleKey] = positionList_zh[i].title;

    const items = positionList_zh[i].items;
    for (let j = 0; j < items.length; j++) {
        const itemTitleKey = `position_item_title${i + 1}_${j + 1}`;
        //const itemContentKey = `position_item_content${i + 1}_${j + 1}`;
        h[itemTitleKey] = items[j].itemTitle;
        //h[itemContentKey] = items[j].itemContent;
        for (let k = 0; k < items[j].itemContent.length; k++) {
            const itemContentKey = `position_item_content${i + 1}_${j + 1}_${k + 1}`;
            h[itemContentKey] = items[j].itemContent[k];
        }
    }
}